import BaseEllipsisText from '@/components/base/BaseEllipsisText';
import { formatDate, type BaseDateTextType } from './formatDate';

export interface BaseDateTextProps {
  value: unknown;
  type?: BaseDateTextType;
  format?: string;
  timeZone?: string;
}

/** 日期统一格式及时区后复用实际截断提示，空值保持空白。 */
export default function BaseDateText({
  value,
  type = 'date',
  format,
  timeZone,
}: BaseDateTextProps) {
  if (value === null || value === undefined) return null;
  return <BaseEllipsisText title={formatDate(value, type, format, timeZone)} />;
}
